<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>更新配置</span>
        </div>
        <el-button
          v-permisaction="['config:hotUpdate:add']"
          style="margin:0px 0px 10px 0px;"
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="edit(form)"
        >新增</el-button>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="gu_version"
            label="版本名称"
            align="center"
          />

          <el-table-column
            prop="gu_title"
            label="版本标题"
            align="center"
          />

          <el-table-column
            prop="gu_force"
            label="强制更新"
            :formatter="getForce"
            align="center"
          />

          <el-table-column
            prop="gu_updateurl"
            label="更新url"
            align="center"
          />

          <el-table-column
            prop="gu_commonurl"
            label="评论url"
            align="center"
          />

          <el-table-column
            prop="gu_hotfix"
            label="热更新地址"
            align="center"
          />

          <el-table-column
            prop="gu_device"
            label="设备"
            align="center"
          />

          <el-table-column
            prop="gu_langtitle"
            label="多语言标题"
            align="center"
          />

          <el-table-column
            prop="gu_langcontent"
            label="多语言内容"
            align="center"
          />

          <el-table-column
            prop="gu_isReward"
            label="是否有奖励"
            align="center"
            :formatter="isReward"
          />

          <el-table-column
            prop="gu_reward"
            label="奖励内容"
            width="150px"
            :formatter="getReward"
          />

          <el-table-column
            prop="gh_news"
            label="是否新的"
            align="center"
            :formatter="isNew"
          />

          <el-table-column
            prop="gu_tips"
            label="是否提醒"
            align="center"
            :formatter="isTips"
          />

          <el-table-column
            fixed="right"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button v-permisaction="['config:hotUpdate:add']" size="mini" @click="edit(scope.row)">编辑</el-button>
              <el-button v-permisaction="['config:hotUpdate:del']" size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-drawer
          title="新增/编辑"
          :visible.sync="drawer"
          direction="rtl"
          :before-close="handleClose"
          size="600px"
        >
          <el-form ref="formData" :inline="true" :model="formData" :rules="rules" label-width="100px" class="demo-ruleForm">
            <el-form-item label="版本" prop="gu_version">
              <el-input v-model="formData.gu_version" placeholder="版本" style="width: 400px" />
            </el-form-item>

            <el-form-item label="版本标题" prop="gu_title">
              <el-input v-model="formData.gu_title" placeholder="版本标题" style="width: 400px" />
            </el-form-item>

            <el-form-item label="强制更新" prop="gu_force">
              <el-select v-model.number="formData.gu_force" placeholder="请选择">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="更新url" prop="gu_updateurl">
              <el-input v-model="formData.gu_updateurl" placeholder="更新url" style="width: 400px" />
            </el-form-item>

            <el-form-item label="评论url" prop="gu_commonurl">
              <el-input v-model="formData.gu_commonurl" placeholder="评论url" style="width: 400px" />
            </el-form-item>

            <el-form-item label="热更新地址" prop="gu_hotfix">
              <el-input v-model="formData.gu_hotfix" placeholder="热更新地址" style="width: 400px" />
            </el-form-item>

            <el-form-item label="设备" prop="gu_device">
              <el-select v-model="formData.gu_device" placeholder="请选择">
                <el-option
                  v-for="item in deviceType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="多语言标题" prop="gu_langtitle">
              <el-input v-model="formData.gu_langtitle" placeholder="多语言标题" style="width: 400px" />
            </el-form-item>

            <el-form-item label="多语言内容" prop="gu_langcontent">
              <el-input v-model="formData.gu_langcontent" placeholder="多语言标题" style="width: 400px" />
            </el-form-item>

            <el-form-item label="更新奖励" prop="gu_isReward">
              <el-select v-model.number="formData.gu_isReward" placeholder="请选择" @change="isRewardChange">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item v-if="formData.gu_isReward === 1" label="金币">
              <el-input v-model.number="formData.gu_reward.money" placeholder="金币" style="width: 400px" />
            </el-form-item>

            <el-form-item v-if="formData.gu_isReward === 1" label="体力">
              <el-input v-model.number="formData.gu_reward.spins" placeholder="体力" style="width: 400px" />
            </el-form-item>

            <el-form-item label="是否新的" prop="gh_news">
              <el-select v-model.number="formData.gh_news" placeholder="请选择">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="是否提醒" prop="gu_tips">
              <el-select v-model.number="formData.gu_tips" placeholder="请选择">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
              <el-input v-model="formData.remark" placeholder="备注" style="width: 400px" />
            </el-form-item>
            <el-form-item style="width:100%;margin-top:50px;text-align: center">
              <el-button v-permisaction="['config:hotUpdate:add']" type="primary" @click="onSubmit('formData')">保存</el-button>
              <!--                            <el-button @click="resetForm('formData')">重置</el-button>-->
            </el-form-item>
          </el-form>
        </el-drawer>

        <div style="text-align: center">
          <!--          <el-button v-permisaction="['config:hotUpdate:add']" type="primary" @click="add()">+</el-button>-->
          <!--          <el-button v-permisaction="['config:startExchange:add']" type="primary" @click="onSubmit()">保存</el-button>-->
        </div>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { delGameUpdate, getGameUpdateList, updateGameUpdateCfg } from '@/api/config/game-update-cfg'
import submenu from 'element-ui/packages/submenu'
export default {
  name: 'GameUpdate',
  data() {
    return {
      drawer: false,
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      propsId: 19,
      statusType: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      deviceType: [
        { label: '安卓', value: 'android' },
        { label: '苹果', value: 'ios' }
      ],
      options: [],
      formData: {},
      form: {
        'id': 0,
        'gu_version': '',
        'gu_title': '',
        'gu_content': '',
        'gu_force': 0,
        'gu_updateurl': '',
        'gu_commonurl': '',
        'gu_hotfix': 0,
        'gu_device': 'android',
        'gu_langtitle': '',
        'gu_langcontent': '',
        'gu_isReward': 0,
        'gu_reward': { 'spins': 80, 'money': 1000000 },
        'gh_news': 0,
        'gu_tips': 0,
        'remark': ''
      },
      tableData: [
        {
          'id': 0,
          'gu_version': '',
          'gu_title': '',
          'gu_content': '',
          'gu_force': 0,
          'gu_updateurl': '',
          'gu_commonurl': '',
          'gu_hotfix': '',
          'gu_device': 'android',
          'gu_langtitle': '',
          'gu_langcontent': '',
          'gu_isReward': 0,
          'gu_reward': { 'spins': 0, 'money': 0 },
          'gh_news': 0,
          'gu_tips': 0
        }
      ], rules: {
        gu_version: [
          { required: true, message: '请输入版本名称', trigger: 'blur' }
        ], gu_title: [
          { required: true, message: '请输入版本标题', trigger: 'blur' }
        ], gu_updateurl: [
          { required: true, message: '请输入更新url', trigger: 'blur' }
        ], gu_commonurl: [
          { required: true, message: '请输入评论url', trigger: 'blur' }
        ], gu_hotfix: [
          { required: true, message: '请输入热更新地址', trigger: 'blur' }
        ], gu_langtitle: [
          { required: true, message: '请输入多语言标题', trigger: 'blur' }
        ], gu_langcontent: [
          { required: true, message: '请输入多语言内容', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    submenu() {
      return submenu
    }
  },
  created() {
    this.getTables()
    // this.getChestSkin()
  },
  methods: {
    edit(row) {
      this.drawer = true
      this.formData = row
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const regex = /^(\d+\.)+\d+$/

          if (!regex.test(this.formData.gu_version)) {
            this.msgError('版本格式有误')
            return
          }
          const data = JSON.stringify(this.formData)
          console.log(data)
          updateGameUpdateCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.drawer = false
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      }
      )
    },
    getTables() {
      this.formData = []
      getGameUpdateList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'gu_version': '',
        'gu_title': '',
        'gu_content': '',
        'gu_force': 0,
        'gu_updateurl': '',
        'gu_commonurl': '',
        'gu_hotfix': '',
        'gu_device': 'android',
        'gu_langtitle': '',
        'gu_langcontent': '',
        'gu_isReward': 0,
        'gu_reward': { 'spins': 0, 'money': 0 },
        'gh_news': 0,
        'gu_tips': 0
      })
      this.dialogVisibleArr.push({ visible: false })
    },
    del(id, index) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delGameUpdate({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    handleClose(done, index) {
      this.$confirm('确定要关闭？')
        .then(_ => {
          this.formData = []
          done()
          this.drawer = false
        })
        .catch(_ => {})
    },
    addRefresh(index) {
      this.formData[index].clear_refresh.push(0)
    },
    delRefresh(index, i) {
      this.formData[index].clear_refresh = this.formData[index].clear_refresh.filter((item, key) => {
        return i !== key
      })
    },
    getChestSkin() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          this.options = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    }, isRewardChange(v) {
      if (v === 0) {
        this.formData.gu_reward = { 'spins': 0, 'money': 0 }
      }
    }, resetForm(formName) {
      this.$refs[formName].resetFields()
    }, getReward(row, col) {
      if (row.gu_isReward === 1) {
        return '金币*' + row.gu_reward.money + ' 体力*' + row.gu_reward.spins
      }
      return '无'
    }, getForce(row, col) {
      if (row.gu_force === 1) {
        return '是'
      }
      return '否'
    },
    isReward(row, col) {
      if (row.gu_isReward === 1) {
        return '是'
      }
      return '否'
    },
    isNew(row, col) {
      if (row.gh_news === 1) {
        return '是'
      }
      return '否'
    },
    isTips(row, col) {
      if (row.gu_tips === 1) {
        return '是'
      }
      return '否'
    }
  }
}
</script>

<style scoped>
</style>
